module.exports = __webpack_public_path__ + "media/customizations/lhermitage/back-20eb0300773558e4ff0c4c0fc6324cd8.jpg";